"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Large_svg_1 = __importDefault(require("./Large.svg"));
const Medium_svg_1 = __importDefault(require("./Medium.svg"));
const Small_svg_1 = __importDefault(require("./Small.svg"));
/**
 * Pin Icon
 */
function PinIcon(props) {
    switch (props.size) {
        case "SMALL":
            return (0, jsx_runtime_1.jsx)(Small_svg_1.default, {});
        case "LARGE":
            return (0, jsx_runtime_1.jsx)(Large_svg_1.default, {});
        case "MEDIUM":
            return (0, jsx_runtime_1.jsx)(Medium_svg_1.default, {});
    }
}
exports.PinIcon = PinIcon;
//# sourceMappingURL=PinIcon.js.map